import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Checkbox from '../Checkbox/Checkbox';
import { requiresCheckoutMarketingConsent } from '../../lib/consent';
import { useMarketingOptIn } from '../../contexts/MarketingOptInContext';
import styles from './MarketingOptInCheckbox.module.scss';

interface MarketingOptInCheckboxProps {
  className?: string;
}

/**
 * Marketing email opt-in checkbox shown to users in GDPR jurisdictions (EU/UK).
 * Unchecked by default — users must actively opt in. Uses OneTrust geo-detection
 * then the edge's GeoIP cookie, and shows whenever the location is unknown.
 *
 * Reads and writes opt-in state from MarketingOptInContext.
 */
export default function MarketingOptInCheckbox({ className }: MarketingOptInCheckboxProps) {
  const { t } = useTranslation();
  const { marketingEmailsOptedIn, setMarketingEmailsOptedIn } = useMarketingOptIn();

  if (!requiresCheckoutMarketingConsent()) {
    return null;
  }

  return (
    <Checkbox
      checked={marketingEmailsOptedIn ?? false}
      onChange={setMarketingEmailsOptedIn}
      label={t('email_me_fi_news_tips_and_offers')}
      className={classNames(styles.marketingOptInCheckbox, className)}
    />
  );
}
